import { FRONTEND_API_BASE } from "../config/apiBase";

const API_BASE = FRONTEND_API_BASE;

export const fetchTracks = () =>
  fetch(`${API_BASE}/tracks`).then((r) => {
    if (!r.ok) throw new Error('Failed to fetch tracks');
    return r.json();
  });

export const fetchTeam = () =>
  fetch(`${API_BASE}/team`).then((r) => {
    if (!r.ok) throw new Error('Failed to fetch team');
    return r.json();
  });

export const fetchGallery = () =>
  fetch(`${API_BASE}/gallery`).then((r) => {
    if (!r.ok) throw new Error('Failed to fetch gallery');
    return r.json();
  });

export const fetchSiteServices = () =>
  fetch(`${API_BASE}/site-services`).then((r) => {
    if (!r.ok) throw new Error('Failed to fetch site services');
    return r.json();
  });

/** Той самий шаблон, що fetchTracks — тільки інший шлях. fetchInit: { signal } для AbortController. */
export const fetchHolidayPromotions = (fetchInit = {}) => {
  const override = (process.env.REACT_APP_HOLIDAY_PROMOTIONS_URL || "").trim();
  const url = override || `${API_BASE}/holiday-promotions`;
  return fetch(url, fetchInit).then((r) => {
    if (!r.ok) throw new Error("Failed to fetch holiday promotions");
    return r.json();
  });
};
